import { Module } from 'wrapper6'
import Swiper from 'swiper/bundle'
import Lightbox from '../utils/_lightbox'

const $ = jQuery

export default class TabsWidget extends Module {
  ready (app) {
    this.createSwiper()

    const WIDGETS = document.querySelectorAll('.mtt-tabs-widget')
    for (let i = 0; i < WIDGETS.length; i++) {
      const TABS_WIDGET_HANDLER = new TabsWidgetHandler(WIDGETS[i])
    }
  }

  createSwiper () {
    return new Swiper('.mtt-tabs-widget .swiper-container', {
      slidesPerView: 'auto',
      speed: 300,
      spaceBetween: 0,
      freeMode: true,
      watchOverflow: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      simulateTouch: false
    })
  }
}

class TabsWidgetHandler {
  constructor (WRAPPER) {
    this.WRAPPER = WRAPPER
    this.ID = this.WRAPPER.getAttribute('id')

    this.TABS = this.WRAPPER.querySelectorAll('.mtt-tabs-widget__nav-item')
    this.SECTIONS = this.WRAPPER.querySelectorAll('.mtt-tabs-widget__content-inner')
    this.SECTION_CONTAINER = this.WRAPPER.querySelector('.mtt-tabs-widget__content')
    this.IMAGE_CONTAINER = this.WRAPPER.querySelector('.mtt-tabs-widget__images')

    if (this.TABS.length > 0 && this.SECTIONS.length > 0) {
      this.checkOverflow(this.TABS[0])

      for (let i = 0; i < this.TABS.length; i++) {
        this.tabClickEvent(this.TABS[i])
      }

      // create lightbox
      const lightBox = new Lightbox(`#${this.ID} .lightbox-image`)
    }
  }

  tabClickEvent (TAB) {
    if (TAB) {
      TAB.addEventListener('click', () => {
        this.setActiveTab(TAB)
        this.setActiveSection(TAB)
        this.toggleImageContainer(TAB)
        this.checkOverflow(TAB)
      })
    }
  }

  setActiveTab (ACTIVE_TAB) {
    for (let i = 0; i < this.TABS.length; i++) {
      this.TABS[i].classList.remove('active')
    }
    ACTIVE_TAB.classList.add('active')
  }

  setActiveSection (ACTIVE_TAB) {
    const TAB_ID = ACTIVE_TAB.getAttribute('data-tab-id')
    for (let j = 0; j < this.SECTIONS.length; j++) {
      const SECTION = this.SECTIONS[j]
      const SECTION_ID = SECTION.getAttribute('id')
      if (SECTION_ID === TAB_ID) {
        SECTION.classList.add('active')
      } else {
        SECTION.classList.remove('active')
      }
    }
  }

  toggleImageContainer (TAB) {
    if (this.IMAGE_CONTAINER && this.SECTION_CONTAINER) {
      const ids = this.IMAGE_CONTAINER.getAttribute('data-show-images').split(', ')
      const tabId = TAB.getAttribute('data-tab-id')
      if (ids.indexOf(tabId) !== -1) {
        this.IMAGE_CONTAINER.classList.remove('hide')
      } else {
        this.IMAGE_CONTAINER.classList.add('hide')
      }
    }
  }

  checkOverflow (TAB) {
    const tabId = TAB.getAttribute('data-tab-id')
    const SECTION = document.getElementById(tabId)
    const CONTENT_WRAP = SECTION.querySelector('.mtt-tabs-widget__content-text')
    const CONTENT_WRAP_INNER = SECTION.querySelector('.mtt-tabs-widget__content-text-inner')
    const READ_MORE_BUTTON = SECTION.querySelector('.mtt-tabs-widget__read-more-text')

    if (READ_MORE_BUTTON && CONTENT_WRAP) {
      const READ_MORE_WRAP = READ_MORE_BUTTON.parentElement

      if (CONTENT_WRAP_INNER.getBoundingClientRect().height <= 456) {
        CONTENT_WRAP.classList.add('open')
        READ_MORE_WRAP.classList.add('hide')
      }

      READ_MORE_BUTTON.addEventListener('click', () => {
        CONTENT_WRAP.classList.add('open')
        READ_MORE_WRAP.classList.add('hide')
      })
    }
  }
}
